import { render, staticRenderFns } from "./MyDrafts.vue?vue&type=template&id=aee5ec60"
import script from "./MyDrafts.vue?vue&type=script&lang=js"
export * from "./MyDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports